import cn from 'classnames';
import Cookies from 'js-cookie';
import { signIn } from 'next-auth/react';
import React, { useState } from 'react';

import Button from 'components/basic/Button';
import { CircularProgress } from 'components/basic/Loaders';
import { providersButtons } from 'components/complex/SocialLogins/const';

import type { SocialProviders } from 'redux-store/slices/profile/types';

import s from './SocialLogins.module.scss';

export default function SocialLogins({
  providers,
  redirectUrl = '',
  buttonClickLogEvent,
}: {
  providers: SocialProviders;
  redirectUrl?: string;
  buttonClickLogEvent: (method: string) => void;
}): JSX.Element {
  const [isLoading, setLoading] = useState(false);

  return (
    <div className={s.wrapper}>
      {providers &&
        Object.values(providers)
          .sort((a, b) => a.id.localeCompare(b.id))
          .map(provider => {
            if (!Object.keys(providersButtons).includes(provider.id)) {
              return;
            }

            const id = provider.id as keyof typeof providersButtons;
            const providerData = providersButtons[id];

            return (
              <div key={provider.name}>
                <Button
                  className={cn(
                    s.button,
                    s[provider.id],
                    `cy-${provider.id}-button`,
                  )}
                  look="secondary"
                  onClick={(): void => {
                    buttonClickLogEvent(provider.name);
                    setLoading(true);

                    Cookies.set('next-auth-redirect-url', redirectUrl);

                    signIn(provider.id, { callbackUrl: redirectUrl });
                  }}
                >
                  {isLoading ? (
                    <CircularProgress />
                  ) : (
                    <>
                      {providerData.img}
                      <span>{providerData.text}</span>
                    </>
                  )}
                </Button>
              </div>
            );
          })}
    </div>
  );
}
